import React, { useEffect, useState } from "react";
import { styled } from '@mui/system'
import useStyles from "../styles/dashboard";
import { Grid } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import { useNavigate } from "react-router-dom";
import CurrencyInput from 'react-currency-input-field';
import AppBar from "../components/AppBar";



interface Props {
    handleEnterPinOpen: ()=>void;
    handleEnterPinClose: ()=>void;

}

const InvestNew: React.FC<Props>=({ handleEnterPinOpen })=>{
    const Main = styled('main')(({ theme }) => ({ }));

    const handleOption1 =()=>{
        document.getElementById('invest-option-2')?.classList.remove('active')
        document.getElementById('invest-option-1')?.classList.add('active')

        document.getElementById('groom-panel-active-option-invest-2')?.classList.remove('active')
        document.getElementById('groom-panel-active-option-invest-1')?.classList.add('active')
    }

    const handleOption2 =()=>{
        document.getElementById('invest-option-1')?.classList.remove('active')
        document.getElementById('invest-option-2')?.classList.add('active')

        document.getElementById('groom-panel-active-option-invest-1')?.classList.remove('active')
        document.getElementById('groom-panel-active-option-invest-2')?.classList.add('active')
    }

    const navigate = useNavigate();
    const handleGoBack = () => {
        if(activeSet === 1){
            navigate(-1)
        }else if(activeSet === 2){
            setActiveSet(1)
            setIsChecked(false)
            document.getElementById(`groom-panel-active-option-investment-new-1`)?.classList.add('active')

            document.getElementById(`groom-panel-active-option-investment-new-2`)?.classList.remove('active')
        }else if(activeSet === 3){
            setActiveSet(2)
            setIsChecked(false)
            document.getElementById(`groom-panel-active-option-investment-new-2`)?.classList.add('active')

            document.getElementById(`groom-panel-active-option-investment-new-3`)?.classList.remove('active')
        }else{
            navigate(-1)
        }
    };

    function calculateProfit(investment: number, months: number, interestRate: number) {
        if (investment <= 0 || months <= 0 || interestRate <= 0) {
          throw new Error("Invalid input: Investment, months, and interest rate must be positive values.");
        }
      
        const timeInYears = months / 12;
      
        const rate = interestRate / 100;
      
        const profit = investment * rate * timeInYears;
      
        return profit;
    }
    function calculateTenPercentRounded(figure: number) {
    // if (isNaN(figure)) {
    //   throw new Error("Invalid input: Please provide a number.");
    // }
    
    const tenPercent = figure * 0.1;
    
    const roundedValue = tenPercent.toFixed(2);
    
    return roundedValue;
    }
    function calculateMaturityDate(months: number) {
    // Check for valid input (optional)
    // if (isNaN(months) || months <= 0) {
    //   throw new Error("Invalid input: Months must be a positive number.");
    // }
    
    const today = new Date();
    
    today.setMonth(today.getMonth() + months);
    
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const year = today.getFullYear();
    
    const maturityDate = `${month}-${day}-${year}`;
    
    return maturityDate;
    }

    const [activePeriod, setActivePeriod] = useState('9')
    const [investmentAmount, setInvestmentAmount] = useState('5000')
    const [monthDuration, setMonthDuration] = useState('3')
    const [activeBtn2, setActiveBtn2] = useState(true)
    const [isChecked, setIsChecked] = useState(false)

    const [profitReturns, setProfitReturns] = useState(0)
    const [activeSet, setActiveSet] = useState(1)

    useEffect(()=>{
        setProfitReturns(calculateProfit(Number(investmentAmount), Number(monthDuration), Number(activePeriod)))
    }, [investmentAmount, activePeriod, monthDuration])

    const handleActivePeriodChange =(idNumberMain: string, idNumber2: string, idNumber3: string, idNumber4: string, idNumber5: string)=>{
        document.getElementById(`investment-new-typesRadioBtn${idNumberMain}`)?.classList.add('active')

        document.getElementById(`investment-new-typesRadioBtn${idNumber2}`)?.classList.remove('active')
        document.getElementById(`investment-new-typesRadioBtn${idNumber3}`)?.classList.remove('active')
        document.getElementById(`investment-new-typesRadioBtn${idNumber4}`)?.classList.remove('active')
        document.getElementById(`investment-new-typesRadioBtn${idNumber5}`)?.classList.remove('active')

        setActivePeriod(idNumberMain)
    }

    const handleSetpChange1 =()=>{
        setActiveSet(2)
        document.getElementById(`groom-panel-active-option-investment-new-1`)?.classList.remove('active')

        document.getElementById(`groom-panel-active-option-investment-new-2`)?.classList.add('active')
    }

    const handleSetpChange2 =()=>{
        setActiveSet(3)
        document.getElementById(`groom-panel-active-option-investment-new-2`)?.classList.remove('active')

        document.getElementById(`groom-panel-active-option-investment-new-3`)?.classList.add('active')
    }

    useEffect(()=>{

        if(Number(investmentAmount) >= 5000 && isChecked){
            setActiveBtn2(false)
        }else{
            setActiveBtn2(true)
        }
        
    }, [ investmentAmount, isChecked ])
    
    
    function formatNumberWithCommas(number: number) {
        // Check for valid input (optional)
        // if (isNaN(number)) {
        //   throw new Error("Invalid input: Please provide a number.");
        // }
      
        // Use toLocaleString for comma separation (modern browsers)
        if (typeof number.toLocaleString === 'function') {
          return number.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
        }
      
        // Fallback for older browsers (manual formatting)
        const parts = number.toString().split('.');
        const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        const decimalPart = parts.length > 1 ? `.${parts[1]}` : '';
        return integerPart + decimalPart;
      }


      
      

    return (
        <main id="content">
            <AppBar />

            <section className="container">

                <div className="transaction-back">
                    <button className="transaction-back-btn" onClick={handleGoBack}>
                        <img src="/imgs/angle.svg" alt="" />
                        <span>Back</span>
                    </button>
                </div>

                <div style={{padding: '3rem 0'}}>
                    <h1 className="tranfer-title-text">Setting Up A New Investment</h1>
                    <p className="tranfer-lead-text">Please select your Investment preferences and start Investing</p>


                    <div id="groom-panel-active-option-investment-new-1" className="groom-panel-2 active" style={{marginBottom: '50px', padding: '2rem 0'}}>
                    
                        <div className="groom-panel-2-inner"  style={{minHeight: 'calc(100vh - 250px)'}}>

                            <div className="groom-panel-2-content">
                               
                               <div className="investment-new-holder">
                                    <div className="investment-new-step">Step 1</div>

                                    <small className="investment-new-text--main">1 of 3 Done</small>
                               </div>

                                <div style={{width: '100%', margin: '1.5rem 0', textAlign: 'left'}}>
                                    <h3 className="investment-new-sub-heading">Duration Category</h3>
                                    <span className="investment-new-tiny__message">Select a Period category you would want to invest within</span>
                                </div>

                                <div className="form-group radio__select">
                                    <label id='investment-new-typesRadioBtn9' className={`radio__select__round-type active`} onClick={()=> handleActivePeriodChange('9', '10', '13', '16', '18')}>
                                        <input type="radio" name="type" value="4110189" defaultChecked/>
                                        <div className="round-type__text ">
                                            <p>Flex 1 - 3 months at 9% Per annum</p>
                                            <span>Penalty fee: 0% of accrued interest</span>
                                        </div>
                                    </label>

                                    <label id='investment-new-typesRadioBtn10' className={`radio__select__round-type `} onClick={()=> handleActivePeriodChange('10', '9', '13', '16', '18')} >
                                        <input type="radio" name="type" value="4110190" />
                                        <div className="round-type__text ">
                                            <p>4 - 6 months at 10% Per annum</p>
                                            <span>Penalty fee: 22% of accrued interest</span>
                                        </div>
                                    </label>

                                    <label id='investment-new-typesRadioBtn13' className={`radio__select__round-type `} onClick={()=> handleActivePeriodChange('13', '10', '9', '16', '18')} >
                                        <input type="radio" name="type" value="4110191" />
                                        <div className="round-type__text ">
                                            <p>7 - 9 months at 13% Per annum</p>
                                            <span>Penalty fee: 38.5% of accrued interest</span>
                                        </div>
                                    </label>

                                    <label id='investment-new-typesRadioBtn16' className={`radio__select__round-type `} onClick={()=> handleActivePeriodChange('16', '10', '13', '9', '18')} >
                                        <input type="radio" name="type" value="4110192" />
                                        <div className="round-type__text ">
                                            <p>10 - 12 months at 16% Per annum</p>
                                            <span>Penalty fee: 50% of accrued interest</span>
                                        </div>
                                    </label>

                                    <label id='investment-new-typesRadioBtn18' className={`radio__select__round-type `} onClick={()=> handleActivePeriodChange('18', '10', '13', '16', '9')} >
                                        <input type="radio" name="type" value="4110193" />
                                        <div className="round-type__text ">
                                            <p>13 - 24 months at 18% Per annum</p>
                                            <span>Penalty fee: 55.5% of accrued interest</span>
                                        </div>
                                    </label>
                                </div>

                                <button onClick={handleSetpChange1} className="btn investment-new-create-acc">Proceed</button>

                            </div>
                        </div>
                    </div>

                    <div id="groom-panel-active-option-investment-new-2" className="groom-panel-2" style={{marginBottom: '50px', padding: '2rem 0'}}>
                    
                        <div className="groom-panel-2-inner"  style={{minHeight: 'calc(100vh - 250px)'}}>

                            <div className="groom-panel-2-content">
                            
                                <div className="investment-new-holder">
                                        <div className="investment-new-step">Step 2</div>

                                        <small className="investment-new-text--main">2 of 3 Done</small>
                                </div>

                                <div style={{width: '100%', margin: '1.5rem 0', textAlign: 'left'}}>
                                    <h3 className="investment-new-sub-heading">Create Investment</h3>
                                    <span className="investment-new-tiny__message">Enter your investment preferences</span>
                                </div>


                                <div style={{marginBottom: '1rem', textAlign: 'left'}}>
                                    <div style={{marginBottom: '.25rem'}}>
                                        <label className="investment-new-low-form-label">Amount ($)</label>
                                        <div style={{position: 'relative'}}>
                                            <CurrencyInput 
                                                id='desiredloadamount'
                                                name="desiredloadamount" 
                                                decimalsLimit={2} 
                                                className='limit-trasacation-search'
                                                defaultValue={'5000'}
                                                onValueChange={(value, name, values) => setInvestmentAmount(value!)}
                                            />
                                            {/* <input name="amount" type="number" maxLength={12} className="investment-new-form-control investment-new-ft-recipient-input" placeholder="Enter Amount" autoComplete="off"/> */}
                                        </div>
                                    </div>
                                    <small className="investent-new-tiny__message">Minimum amount to invest is $5,000.00</small>
                                </div>

                                <div className="investment-new-select-field-container" style={{width: '100%', textAlign: 'left', marginBottom: '1rem'}}>
                                        <label>Select Investment Duration</label>

                                        <select 
                                            name="investment-duration" 
                                            id="investment-new-investment-duration"
                                            className="investment-new-form-control investment-new-ft-recipient-input"
                                            style={{ background: 'rgb(235, 236, 239)', fontSize: '0.9rem', color: '#000'}}
                                            onChange={(e)=> setMonthDuration(e.currentTarget.value)}    
                                        >
                                                {/* <option value="" disabled selected>Choose Duration</option> */}
                                                <option value="3">3 Months</option>
                                                <option value="6">6 Months</option>
                                                <option value="12">12 Months</option>
                                        </select>
                                </div>

                                <div style={{marginBottom: '1rem', textAlign: 'left'}}>
                                    <div style={{marginBottom: '.25rem'}}>
                                        <label className="investment-new-low-form-label">Referral Code (optional)</label>
                                        <div style={{position: 'relative'}}>
                                            <input name="amount" type="text" maxLength={12} className="investment-new-form-control investment-new-ft-recipient-input" placeholder="Enter referral code" autoComplete="off"/>
                                        </div>
                                    </div>
                                </div>


                                <div style={{padding: '1.5rem 0', textAlign: 'left'}}>
                                    <div className="investment-new-custom-control-custom-checkbox">
                                        <input type="checkbox" className="investment-new-custom-control-input" id="terms" name="terms" checked={isChecked} onChange={(event) => setIsChecked(event.target.checked)}/>
                                        <div className="investment-new-custom-control-label-zero-text">Mintyn investment<a href="https://mintyn.com/terms" className="investment-new-specialLink" target="_blank" rel="noopener noreferrer">Terms and Conditions</a>, I confirm that I act on my own behalf</div>
                                    </div>
                                    <small className="investment-new-zero-text">I hereby create a Mintyn Investment according to the following legal documents which I have read and to which I consent</small>
                                </div>

                               

                                <button onClick={handleSetpChange2} className="btn investment-new-create-acc" style={activeBtn2 ? {opacity: '.65'} : {}} disabled={activeBtn2}>Proceed</button>

                            </div>
                        </div>

                    </div>


                    <div id="groom-panel-active-option-investment-new-3" className="groom-panel-2" style={{marginBottom: '50px', padding: '2rem 0'}}>
                        <div className="groom-panel-2-inner"  style={{minHeight: 'calc(100vh - 250px)'}}>
                            <div className="groom-panel-2-content">
                            
                                <div className="investment-new-holder">
                                        <div className="investment-new-step">Step 3</div>

                                        <small className="investment-new-text--main">3 of 3 Done</small>
                                </div>

                                <div style={{width: '100%', margin: '1.5rem 0', textAlign: 'left'}}>
                                    <h3 className="investment-new-sub-heading">Preview Investment</h3>
                                    <span className="investment-new-tiny__message">Summary of your investment details</span>
                                </div>


                                <div className="investment-new-step-3">
                                    <ul style={{marginTop: '1.5rem'}}>
                                        <li style={{borderBottom: '1px solid #dee2e6'}}>
                                            <h4>INVEST</h4>
                                            <h4 style={{color: '#28a745'}}>${formatNumberWithCommas(Number(investmentAmount))}.00</h4>
                                        </li>
                                        <li>
                                            <div>
                                                <p>Profit Returns</p>
                                                <h4>${formatNumberWithCommas(profitReturns)}.00</h4>
                                            </div>
                                            <div>
                                                <p>Percent</p>
                                                <h4>{activePeriod}% P/A</h4>
                                            </div>
                                        </li>
                                        <li>
                                            <div>
                                                <p>Duration</p>
                                                <h4>{monthDuration} months</h4>
                                            </div>
                                            <div>
                                                <p>Maturity Date</p>
                                                <h4>{calculateMaturityDate(Number(monthDuration))}</h4>
                                            </div>
                                        </li>
                                        <li>
                                            <div>
                                                <p>Withholding Tax</p>
                                                <h4>${formatNumberWithCommas(Number(calculateTenPercentRounded(profitReturns)))}.00</h4>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                                

                                <button type="button" className="btn investment-new-create-acc" onClick={handleEnterPinOpen}>Proceed</button>

                            </div>
                        </div>
                    </div>




                </div>


            </section>

        </main>
    )
}

export default InvestNew